import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { createMarkup } from '../../shared/logic/Utils';
import makeStyles from '@mui/styles/makeStyles';
import Header from '../components/Header';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { contactImage } from '../../shared/logic/imagesFns';
import { textVariant, textClasses } from '../../shared/config';

const useStyles = makeStyles((theme) => ({
    descSpan:{
        paddingTop:'25px',
        fontSize:'16px',
        width:'100%',
        textOverflow:'ellipsis',
        '& li':{
        listStyle:'inherit'
        },

        [theme.breakpoints.down('sm')]:{
        paddingTop:'16px', 
        }
    },
}));

const RefundPolicy = () => {
  const { data } = useCompanyData();
  const { t, fontFamily, refundLink } = data;
  const classes = useStyles();

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  return (
    <>
        <SimpleHeader
            {...{title:t && t('booking.refund'),data}}
        />
        <Box
            py={5}
            width="90%"
            m="auto"
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mt="100px"
        >
            <Typography variant="body1" className={classes.descSpan} style={{fontFamily}} dangerouslySetInnerHTML={createMarkup(refundLink)}></Typography>
        </Box>
    </>
  );
};

function SimpleHeader({data,title}) {
  const { fontFamily, displayBanner=true, generalTitleFontSize } = data || {};
  const variant = generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];

  return(
    <Header
      image={contactImage(data,'t3')}
      height="600px"
      transparencyColor={'#15476db2'}
      bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
      displayBanner={displayBanner}
      titleColor={data.bannerFontColor}
      data={data}
      position="relative"
    >
      <div style={{zIndex:1}}>
        <Box pb={7}>
          <Typography
            variant={variant}
            className={fontSizeCls}
            style={{ color: 'white', fontWeight: 'bold',textTransform:'capitalize', fontFamily }}
          >
            {title}
          </Typography>
        </Box>
      </div>
    </Header>
  )
}

export default RefundPolicy;